export const getMethods = (state) => state.methods